import { render, staticRenderFns } from "./Sidebaritem_left.vue?vue&type=template&id=50c5fdda&scoped=true&"
import script from "./Sidebaritem_left.vue?vue&type=script&lang=js&"
export * from "./Sidebaritem_left.vue?vue&type=script&lang=js&"
import style0 from "./Sidebaritem_left.vue?vue&type=style&index=0&id=50c5fdda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5fdda",
  null
  
)

export default component.exports